<template>
  <section class="tw-flex tw-flex-col tw-items-start apDesktop:tw-pb-6 tw-pb-4">
    <div>
      <p
        :class="[
          'works-group animate__animated animate__fadeInUp tw-self-stretch apDesktop:tw-text-label-semi-bold-desktop tw-text-label-semi-bold-mobile tw-uppercase dark:tw-text-white tw-text-ap-nero tw-mb-4'
        ]"
      >
        {{ obj?.group ?? '' }}
      </p>
      <p
        class="works-title animate__animated animate__fadeInUp tw-w-full md:tw-w-[90%] lg:tw-w-[800px] apDesktop:tw-text-h2-semi-bold-desktop tw-text-h2-semi-bold-mobile dark:tw-text-white tw-text-ap-nero  tw-mb-4 md:tw-mb-8"
      >
        {{ obj?.title ?? '' }}
      </p>
      <div
        class="works-subtitle animate__animated animate__fadeInUp template-6 apDesktop:tw-text-body-desktop tw-text-body-mobile dark:tw-text-white tw-text-ap-nero tw-mb-8 md:tw-mb-12"
        v-html="obj?.subtitle ?? ''"
      />

      <a
        :href="obj?.hyperlink.link ?? '#'"
        target="_blank"
        class="works-hyperlink animate__animated animate__fadeInUp tw-text-blue-500 hover:tw-text-blue-700 tw-transition-all apDesktop:tw-text-body-desktop tw-text-label-mobile"
      >
        {{ obj?.hyperlink.label ?? '' }}
      </a>
    </div>
    
    <div v-if="obj?.header" class="works-header animate__animated animate__fadeInUp tw-flex tw-flex-col tw-items-start tw-gap-2 tw-self-stretch tw-pb-16">
      <img :src="$cdn(obj?.header ?? '')" alt="header-image" class="tw-w-[800px] tw-h-[478] tw-flex-shrink-0">
    </div>
    <div v-for="(item) in objContent" class="works-content animate__animated animate__fadeIn tw-w-full">
      <!-- template 1 -->
      <div
        v-if="item.acf_fc_layout === 'template_1'"
        class="tw-flex apDesktop:tw-flex-row tw-flex-col tw-items-center tw-gap-10 tw-self-stretch"
      >
        <img :src="cdn(item.image)" alt="Icon" class="apDesktop:tw-w-[380px] apDesktop:tw-h-[380px] tw-flex-shrink-0 tw-object-cover">
        <div class="tw-flex tw-flex-col tw-items-start tw-w-full tw-gap-4 apDesktop:tw-gap-6">
          <div
            class="apDesktop:tw-w-[380px] tw-w-full tw-text-ap-nero dark:tw-text-white apDesktop:tw-text-body-semi-bold-desktop tw-text-body-semi-bold-mobile" 
            v-html="item.description" 
          />
          <p
            class=" tw-text-ap-nero dark:tw-text-white apDesktop:tw-text-label-desktop tw-text-label-mobile"
          >
            {{ item.sub_description }}
          </p>
        </div>
      </div>

      <!-- template 2 -->
      <div
        v-else-if="item.acf_fc_layout === 'template_2'"
        class="tw-flex apDesktop:tw-flex-row tw-flex-col tw-items-start tw-gap-10"
      >
        <!-- Left Side: Title -->
        <div v-for="(text, index) in item.texts" :key="index" class="tw-flex tw-flex-col tw-items-start tw-gap-4 apDesktop:tw-gap-6">
          <div
            class="tw-text-ap-nero dark:tw-text-white apDesktop:tw-text-body-semi-bold-desktop tw-text-body-semi-bold-mobile"
            v-html="text.description"
          />
          <p
            class="tw-text-ap-nero dark:tw-text-white apDesktop:tw-text-label-desktop tw-text-label-mobile"
          >
            {{ text.sub_description }}
          </p>
        </div>
      </div>

      <div v-else-if="item.acf_fc_layout === 'template_3'">
        <video
          :src="cdn(item.video)"
          controls
          class="tw-w-full"
          preload="metadata"
          playsinline
          muted   
        />
      </div>

      <!-- template 4 -->
      <!-- New Container with 2 Rows, 2 Images Per Row -->
      <div v-else-if="item.acf_fc_layout === 'template_4'" class="tw-grid tw-grid-cols-2 apDesktop:tw-gap-10 tw-gap-4">
        <!-- Image 1 in the first row -->
        <div v-for="(smallImage, _) in item.images" class="tw-flex tw-flex-col tw-gap-2 apDesktop:tw-gap-4">
          <img
            :src="cdn(smallImage.image)"
            alt="Icon"
            :class="[
              'apDesktop:tw-w-[380px] apDesktop:tw-h-[380px] tw-flex-shrink-0 tw-object-cover'
            ]"
          >
          <div v-if="smallImage.image_description" class="tw-text-ap-nero dark:tw-text-ap-very-light-grey tw-text-label-md-mobile apDesktop:tw-text-label-md-desktop">
            {{ smallImage.image_description }}
          </div>
        </div>
      </div>

      <!-- template 5 -->
      <!-- New Container with single image -->
      <div
        v-else-if="item.acf_fc_layout === 'template_5'"
        class="tw-w-full tw-flex tw-flex-col tw-gap-4"
      >
        <img :src="item.image" alt="image" class="tw-object-cover tw-h-full tw-w-full">
        <div v-if="item.caption" class="tw-text-ap-nero dark:tw-text-ap-very-light-grey tw-text-label-md-mobile apDesktop:tw-text-label-md-desktop">
          {{ item.caption }}
        </div>
      </div>

      <!-- template 6 : text only -->
      <div v-else-if="item.acf_fc_layout === 'template_6'" class="template-6 tw-text-ap-nero dark:tw-text-white">
        <div v-if="item.caption" class="tw-text-label-semi-bold-mobile apDesktop:tw-text-label-semi-bold-desktop tw-uppercase tw-pb-4" v-html="item.caption" />
        <div v-if="item.title" class="tw-text-h3-mobile apDesktop:tw-text-h3-desktop tw-pb-8" v-html="item.title" />
        <div class="tw-text-body-mobile apDesktop:tw-text-body-desktop" v-html="item.text" />
      </div>

      <div
        v-if="item.has_divider"
        :class="[
          'apDesktop:tw-mt-8 apDesktop:tw-mb-8 tw-my-6',
          'apDesktop:tw-w-[800px] tw-w-full tw-h-[1px] tw-flex-shrink-0 tw-bg-ap-nobel dark:tw-bg-ap-dim-grey'
        ]"
      />
      <div v-else class="tw-w-full tw-h-8 apDesktop:tw-h-16" />
    </div>
  </section>
</template>

<script setup lang="ts">
import { computed, onBeforeUnmount, onMounted } from 'vue';
import { Work } from '../../model/interfaces/WorkInterface';
import { cdn } from '../../support/cdn';


const props = defineProps({
  data: Object as () => Work,
});

const obj = computed(() => {
  return props.data?.modal_content;
});

const objContent = computed(() => {
  return obj.value?.content;
});

onMounted(() => {
  window.history.pushState({}, '', '/work/' + props.data.slug);
})

onBeforeUnmount(() => {
  window.history.replaceState({}, '', '/');
})

</script>

<style scoped>

.template-6:deep(ul) {
  list-style-type: disc;
  margin-left: 1.5rem;
}

.template-6:deep(ul ul) {
  list-style-type: "- ";
  margin-left: 1.5rem;
}

.works-group {
  animation-delay: 300ms !important;
}
.works-title {
  animation-delay: 400ms !important;
}
.works-subtitle {
  animation-delay: 500ms !important;
}
.works-hyperlink {
  animation-delay: 600ms !important;
}
.works-header {
  animation-delay: 700ms !important;
}
.works-content {
  animation-delay: 800ms !important;
  animation-duration: 500ms !important;
}

.works-group,
.works-title,
.works-subtitle,
.works-hyperlink,
.works-header {
  animation-duration: 300ms !important;
}

</style>